// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import * as tab0 from '/vercel/path0/docs/guide/page-tab.$tab-example.md';

export const tabs = {
  'docs/guide/page-tab.$tab-example': { key: 'example', title: '', titleIntlId: '', components: tab0 },
}
